import React, { useState, useEffect, forwardRef, useImperativeHandle } from "react";
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";

const OutlinedTextField = forwardRef((props, ref, ...rest) => {
    const [inputValue, setInputValue] = useState(props.value);
    const [hasError, setHasError] = useState(false);

    useEffect(() => {
        console.log("Plaintext :: ", inputValue);
    }, [inputValue]);

    useImperativeHandle(ref, () => ({
        validate() {
            return isValidData();
        },
    }));

    const isValidData = () => {
        if (props.isRequired) {
            if (inputValue) {
                setHasError(false);
                return !false;
            } else {
                setHasError(true);
                return !true;
            }
        } else {
            setHasError(false);
            return !false;
        }
    };

    const handleChange = (event) => {
        let newValue = event.target.value;
        setInputValue(newValue);
        props.onChange(newValue);
        props.isRequired ? (newValue?.length > 0 ? setHasError(false) : setHasError(true)) : setHasError(false);
    };

    const validateInput = (event) => {
        if (props.isRequired) {
            if (inputValue?.trim() === "" || inputValue === undefined) {
                setHasError(true);
            }

            props.onChange(inputValue?.trim());
            if (props.onBlur) {
                props.onBlur(inputValue?.trim());
            }
        } else {
            setHasError(false);
            if (props.onBlur) {
                props.onBlur(inputValue?.trim());
            }
        }
    };

    const removeValidate = (event) => {
        setHasError(false);
    };

    return (
        <div>
            <FormControl {...rest} sx={{ my: 2 }} fullWidth variant="outlined">
                <TextField
                    {...rest}
                    id={props.id}
                    sx={{
                        "& .MuiOutlinedInput-notchedOutline": {
                            border: props.readOnly ? "none" : "1px solid #d6d6d6",
                        },
                        "&:hover > .MuiOutlinedInput-notchedOutline": {
                            border: props.readOnly ? "none" : "1px solid #d6d6d6",
                        },
                    }}
                    required={props.isRequired}
                    label={props.label}
                    value={inputValue}
                    variant="outlined"
                    onChange={handleChange}
                    onBlur={validateInput}
                    onFocus={removeValidate}
                    InputProps={{
                        readOnly: props.readOnly,
                    }}
                />
            </FormControl>
        </div>
    );
});

export default OutlinedTextField;
